/**
 * Decide whether a tldraw store side-effect should be ignored by the board's
 * autosave / dirty tracking because it originates from the programmatic board
 * rebuild rather than a genuine user edit.
 *
 * It's programmatic when either:
 *  - tldraw tagged the change `source: 'remote'` — `createNodes` wraps the
 *    board rebuild in `editor.store.mergeRemoteChanges()`, so every shape edit
 *    it makes arrives as `'remote'`; or
 *  - the legacy `isEffectUpdatingRef` backstop is set (covers any rebuild edit
 *    not routed through `mergeRemoteChanges`).
 *
 * Extracted from BoardCanvas so the gating contract behind the FS-502
 * autosave-loop fix is unit-tested independently of a live tldraw editor.
 * If this returns true, the shape change/delete side-effect handlers must
 * return early (no `updateBoard`, no `flushDeletes`/save).
 */
export function isProgrammaticChange(
  source: 'remote' | 'user',
  isEffectUpdating: boolean,
): boolean {
  return source === 'remote' || isEffectUpdating
}
